import React, { useState } from "react";
import Auth from "../../utils/auth";

const AdminSideBar = ({
  VisibilityCard,
  VisibilityUserList,
  VisibilityPostList,
  VisibilityChangePw,
  VisibilityAnalytics,
  VisibilityAnnouncements,
  VisibilitySide,
}) => {
  const [active1, setActive1] = useState(true);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);

  // Hover state tracking
  const [hoveredIdx, setHoveredIdx] = useState(null);

  // --- PERFECTED LAYOUT STYLES ---
  const asideStyle = {
    display: "flex",
    flexDirection: "column",
    width: "280px",
    minWidth: "280px",
    height: "100vh",
    background: "#ffffff",
    padding: "32px 20px 24px 20px",
    borderRight: "1px solid #e2e8f0",
    position: "sticky",
    top: 0,
    boxSizing: "border-box",
  };

  const logoContainerStyle = {
    display: "flex",
    justifyContent: "center", // Centers the logo horizontally within the sidebar container
    alignItems: "center",
    marginBottom: "36px", // Clean layout breathing room below the larger logo
    width: "100%",
  };

  const logoStyle = {
    height: "42px", // Upscaled branding height for better readability
    width: "auto",
    objectFit: "contain",
  };

  const topNavigationLinksStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    justifyContent: "flex-start",
    height: "auto",
  };

  const bottomNavigationLinksStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginTop: "auto",
    paddingTop: "16px",
  };

  const getLinkStyle = (isActive, index) => {
    const isCurrentlyHovered = hoveredIdx === index;

    let backgroundColor = "transparent";
    let color = "#64748b";
    let fontWeight = "500";

    if (isActive) {
      backgroundColor = "#e7f1ff";
      color = "#007bff";
      fontWeight = "600";
    } else if (isCurrentlyHovered) {
      backgroundColor = "#f8fafc";
      color = "#0f172a";
    }

    return {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      padding: "12px 16px",
      borderRadius: "12px",
      textDecoration: "none",
      color: color,
      backgroundColor: backgroundColor,
      fontWeight: fontWeight,
      transition: "all 0.15s ease-in-out",
      cursor: "pointer",
      fontSize: "14px",
    };
  };

  const iconStyle = (isActive) => ({
    fontSize: "20px",
    color: isActive ? "#007bff" : "#94a3b8",
  });

  const dividerStyle = {
    height: "1px",
    backgroundColor: "#f1f5f9",
    margin: "0 12px 12px 12px",
  };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons+Sharp"
        rel="stylesheet"
      />

      <aside
        style={asideStyle}
        className={VisibilitySide === true ? "d-block" : ""}
      >
        {/* LOGO AREA (Centered and Upscaled) */}
        <div style={logoContainerStyle}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="images/logo/MEGAGEN_LOGO_black.webp"
              alt="Logo"
              style={logoStyle}
            />
          </a>
        </div>

        {/* TOP MENU: Stacked tightly under each other */}
        <div style={topNavigationLinksStyle}>
          {/* 1. Dashboard */}
          <a
            style={getLinkStyle(active1, 1)}
            onMouseEnter={() => setHoveredIdx(1)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={() => {
              VisibilityCard(true);
              VisibilityChangePw(true);
              VisibilityPostList(false);
              VisibilityUserList(false);
              VisibilityAnalytics(false);
              VisibilityAnnouncements(false);
              setActive1(true);
              setActive2(false);
              setActive3(false);
            }}
          >
            <span className="material-icons-sharp" style={iconStyle(active1)}>
              dashboard
            </span>
            <span>Dashboard</span>
          </a>

          {/* 2. Users */}
          <a
            style={getLinkStyle(active2, 2)}
            onMouseEnter={() => setHoveredIdx(2)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={() => {
              VisibilityCard(false);
              VisibilityChangePw(false);
              VisibilityPostList(false);
              VisibilityUserList(true);
              VisibilityAnalytics(false);
              VisibilityAnnouncements(false);
              setActive1(false);
              setActive2(true);
              setActive3(false);
            }}
          >
            <span className="material-icons-sharp" style={iconStyle(active2)}>
              people_alt
            </span>
            <span>Users</span>
          </a>

          {/* 3. Marketing Material */}
          <a
            style={getLinkStyle(active3, 3)}
            onMouseEnter={() => setHoveredIdx(3)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={() => {
              VisibilityCard(false);
              VisibilityChangePw(false);
              VisibilityPostList(true);
              VisibilityUserList(false);
              VisibilityAnalytics(false);
              VisibilityAnnouncements(false);
              setActive1(false);
              setActive2(false);
              setActive3(true);
            }}
          >
            <span className="material-icons-sharp" style={iconStyle(active3)}>
              auto_stories
            </span>
            <span>Marketing Material</span>
          </a>
        </div>

        {/* BOTTOM MENU: Separated and anchored at the base */}
        <div style={bottomNavigationLinksStyle}>
          <div style={dividerStyle} />

          {/* Back Home */}
          <a
            className="home-link"
            href="/"
            style={getLinkStyle(false, 4)}
            onMouseEnter={() => setHoveredIdx(4)}
            onMouseLeave={() => setHoveredIdx(null)}
          >
            <span className="material-icons-sharp" style={iconStyle(false)}>
              arrow_back
            </span>
            <span>Back Home</span>
          </a>

          {/* Logout */}
          <a
            style={getLinkStyle(false, 5)}
            onMouseEnter={() => setHoveredIdx(5)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={() => Auth.logout()}
          >
            <span
              className="material-icons-sharp"
              style={{ ...iconStyle(false), color: "#dc3545" }}
            >
              logout
            </span>
            <span style={{ color: "#dc3545", fontWeight: "600" }}>Logout</span>
          </a>
        </div>
      </aside>
    </>
  );
};

export default AdminSideBar;
